import GroupControlIcon from './component'

export default GroupControlIcon
